import React from 'react';
import ReactDOM from 'react-dom/client';
import { HashRouter, Routes, Route } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import App from './component/App';
import './scss/main.scss';
import Home from './component/home';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
        <HashRouter>
            <Routes>
                <Route path='/' element={<Home />} ></Route>
                <Route path='/:id' element={<App />} ></Route>
                <Route path='*' element={<App />} ></Route>
            </Routes>    
            <ToastContainer />
        </HashRouter>
);